import { FileText } from "lucide-react";
import { formatDuration } from "@/lib/utils";
import type { RecordIconProps } from "../types/recordHeader.types";

export const RecordIcon = ({ duration, className = "" }: RecordIconProps) => {
  return (
    <div className={`h-14 w-11 sm:h-16 sm:w-12 bg-gradient-to-br from-brand-50 to-brand-100 rounded-xl flex flex-col items-center justify-center border border-brand-200 shadow-sm py-1 hover:shadow-md transition-shadow ${className}`}>
      <FileText size={16} className="text-brand-600 w-4 h-4 sm:w-[18px] sm:h-[18px]" />
      <span className="text-[8px] sm:text-[9px] font-bold text-brand-700 leading-none mt-0.5 sm:mt-1">
        {formatDuration(duration)}
      </span>
    </div>
  );
};